export function formatNumber(num, fraction) {
    const fract = fraction || 2;
    return num.toFixed(fract);
}

export function formatRoundNumber(num, fraction) {
    const fract = fraction || 2;
    return (Math.round(num * 100) / 100).toFixed(fract);
}

export function formatCurrency(num, fraction = 2, locale = 'en-GB', currency = 'GBP') {
    return num.toLocaleString(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: fraction,
        maximumFractionDigits: fraction
    });
}